module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/menu-3d3b41b2028ccc3c3ee8354d7ac6b07a.jpeg";